import { z } from 'zod';

/////////////////////////////////////////
// NOTIFY TWITTER CONTENT SCHEMA
/////////////////////////////////////////

export const NotifyTwitterContentSchema = z.object({
  integrationId: z.bigint(),
  cityId: z.number().int(),
  notificationCmsId: z.bigint(),
  notifyContentId: z.number().int().nullable(),
})

export type NotifyTwitterContent = z.infer<typeof NotifyTwitterContentSchema>

export default NotifyTwitterContentSchema;
